module.exports = __webpack_public_path__ + "img/cvonline.7845566e.jpg";